import { Theme } from "@mui/material";
import { SxProps } from "@mui/system";

export const getMainContainerBoxWidth = (theme: Theme, pathname: string): SxProps<Theme> => {
  return {
    width:
      pathname === "/" || pathname === "/schedule"
        ? {
            xs: "80%",
            sm: "86%",
            md: "87%",
            lg: "89%",
            xl: "92%",
            xxl: "94%",
          }
        : "100%",
    marginRight: "20px",
  };
};

export const mainContainerHeight = (pathname: string): string | undefined => {
  if (pathname === "appointments") {
    return "calc(100vh - 92px)";
  }
};
